export const base = 'dashboard';

export const getDashBoard = `${base}/dashboard`;
